/**
 * The numbers and lists the signed-out landing page (features/landing) is
 * tuned by: how many gardens it shows, and the seed-packet section's photos.
 *
 * Kept out of the components so each can be found and changed without reading
 * the component behind it. Constants only: no functions, and no imports of
 * the app's code, so anything may import this without a cycle.
 *
 * Not here: the dates and prices the page says (the founding day, the launch
 * prices, the trial's length), Free's plants, the founding places and the
 * owner's garden address. Those are the owner's Grow settings, and the
 * server sends them (GET /billing/landing; architecture audit batch 8), so
 * the page follows the panel.
 *
 * Used by: features/landing (the Gardens and seed-packet sections).
 *
 * @module tunables/landing
 */

/** The most gardens the "Gardens growing on Grow" strip shows, newest first, from Gardens on Grow. A count. @kept K5 */
export const LANDING_GARDENS_MAX = 6;

/**
 * The seed-packet section's photos, one address per slot, all here. The
 * photos are the owner's own packet scan of their bed "Side garden": the
 * whole pile, and three of the six packets Grow cut out of it. Each is null
 * if the file is taken away, and the section then shows a plain framed box in
 * its place. To change a slot, put the image under public/landing/ and set
 * its path here; nothing else changes (the words naming each packet are
 * landing.packets.items.packetN and landing.slots.packetN).
 * @kept K5
 */
export const LANDING_PACKET_PHOTOS: Readonly<Record<'pile' | 'packet1' | 'packet2' | 'packet3', string | null>> = {
  pile: '/landing/packets-pile.jpg',
  packet1: '/landing/packets-1.jpg',
  packet2: '/landing/packets-2.jpg',
  packet3: '/landing/packets-3.jpg',
};
